import { combineReducers, createReducer, on } from '@ngrx/store';
import { omit } from 'lodash';
import * as ConversationActions from '../actions/message-conversation.actions';
import * as MessageActions from '../actions/message.actions';
import { WrapUpsSubState } from '../../common/models/wrap-up-sub-state.model';
import { ConversationsSubState, GenesysCloudMessagesSubState, initialConversationMessagesSubState, initialConversationsSubState, initialWrapUpsSubState } from '../genesys-cloud-message-conversations.state';
import { messageConversationEntityAdapter } from '../adapters/message-conversation.adapter';
import { messageEntityAdapter } from '../adapters/message.adapter';

const messageConversationsReducer = createReducer(
  initialConversationsSubState(),
  on(ConversationActions.messageConversationsLoaded, (state, { conversations }): ConversationsSubState => messageConversationEntityAdapter.setAll(conversations, state)),
  on(ConversationActions.messageConversationChanged, (state, { conversation }): ConversationsSubState => messageConversationEntityAdapter.setOne(conversation, state)),
  on(ConversationActions.evictMessageConversation, (state, { conversationId }): ConversationsSubState => messageConversationEntityAdapter.removeOne(conversationId, state))
);

const messagesReducer = createReducer(
  initialConversationMessagesSubState(),
  on(MessageActions.messagesLoaded, (state: GenesysCloudMessagesSubState, { conversationId, messages }): GenesysCloudMessagesSubState => {
    const existingSubState = state[conversationId] ?? messageEntityAdapter.getInitialState();
    return {
      ...state,
      [conversationId]: messageEntityAdapter.upsertMany(messages, existingSubState)
    };
  }),
  on(MessageActions.sendMessageSuccess, (state: GenesysCloudMessagesSubState, { conversationId, message }): GenesysCloudMessagesSubState => {
    const existingSubState = state[conversationId] ?? messageEntityAdapter.getInitialState();
    return {
      ...state,
      [conversationId]: messageEntityAdapter.upsertOne(message, existingSubState)
    };
  }),
  on(ConversationActions.evictMessageConversation, (state, { conversationId }): GenesysCloudMessagesSubState => omit(state, conversationId))
);

const wrapUpsReducer = createReducer(
  initialWrapUpsSubState(),
  on(ConversationActions.wrapUpsLoadedForMessageConversation, (state: WrapUpsSubState, { conversationId, wrapUpCodes }): WrapUpsSubState => ({
    ...state,
    [conversationId]: [...wrapUpCodes]
  })),
  on(ConversationActions.evictMessageConversation, (state, { conversationId }): WrapUpsSubState => omit(state, conversationId))
);

export const genesysCloudMessageConversationsReducer = combineReducers({
  conversations: messageConversationsReducer,
  messages: messagesReducer,
  wrapups: wrapUpsReducer
});
